import(/* webpackMode: "eager" */ "/usr/src/app/apps/main/components/accordions-with-image/AccordionsWithImage.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/main/components/card-slider/CardSlider.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/main/components/gallery-slider/GallerySlider.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/main/components/hero/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroImage"] */ "/usr/src/app/apps/main/components/hero/HeroImage.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/main/components/hotel-hover-gallery/HotelHoverGallery.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/main/components/items-slider/ItemsSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/apps/main/components/map-interactive/MapInteractive.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/apps/main/components/pre-intro/PreIntro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/usr/src/app/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
